import React from 'react';
import { View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import RemoteProjectsScreen from '@/components/Settings/RemoteProjectsScreen';
import { Redirect } from 'expo-router';
import { isMacAppStore } from '@/lib/appDistribution';
export default function RemoteProjectsRoute() {
  const { colors } = useTheme();
  if (isMacAppStore()) return <Redirect href="/app" />;
  return <View style={{ flex: 1, backgroundColor: colors.solid_color_primary }}><RemoteProjectsScreen workspace /></View>;
}
